<template>
  <div>
    <Timetable :id="id" type="staff" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import Timetable from '@/components/common/Timetable.vue';

export default {
  name: 'staff-timetable',
  props: ['id'],
  components: {
    Timetable,
  },
  methods: {
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>

<style lang="scss"></style>
